export const MaxLengths = {
  Email: 100,
  Password: 20,
  FirstName: 32,
  LastName: 32,
  Address: 32,
};

export const IDENTITY_WIDGET_BASEPATH = process.env.BASE_PATH || '/identity';

export enum IDENTITY_WIDGET_PATHS {
  /** Regular Flows */
  SignInOrJoin = '/',
  SignIn = '/signin',
  SignInAuthSelection = '/signin-auth',
  SignUp = '/signup',
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password/:token',
  ChangePassword = '/change-password',
  MlifeActivation = '/activate',

  /** Session/Token Exchange Flows */
  OktaRedirect = '/auth/login',
  AuthMobile = '/auth/mobile',

  /** Partner Link Flows */
  PartnerLink = '/auth/partner-link',
  MarriottBonvoyAuthorize = '/external/authorize/marriott',
  MarriottBonvoyPartnerLink = '/external/authentication/east',

  /** MFA Flows */
  MfaContactSupport = '/mfa/contact-support',
  /** MFA Enrollment */
  MfaEnroll = '/mfa/enroll',
  MfaEnrollEmail = '/mfa/enroll/email',
  MfaEnrollSms = '/mfa/enroll/sms',
  MfaEnrollSmsVerify = '/mfa/enroll/sms-verify',
  MfaEnrollPasskey = '/mfa/enroll/passkey',
  /** MFA Authentication */
  MfaAuthEmail = '/mfa/auth/email',
  MfaAuthSms = '/mfa/auth/sms',
  MfaAuthPasskey = '/mfa/auth/passkey',
}

export const IDW_FLOW_PARAM = 'idwFlow';
export const MFA_ENROLL_STATUS_PARAM = 'mfa_enroll_status';

export const defaultRedirectPath = '/en.html';
export const defaultRedirectProfilePath = '/account/profile';
export const defaultProfile2FAPath = '/account/security/2fa';
export const defaultRewardsPath = '/rewards';

export const REWARDS_MARRIOTT_LINKING_PATHS = [
  `${IDENTITY_WIDGET_BASEPATH}${IDENTITY_WIDGET_PATHS.MarriottBonvoyAuthorize}`,
  `${IDENTITY_WIDGET_BASEPATH}${IDENTITY_WIDGET_PATHS.MarriottBonvoyPartnerLink}`,
];

export enum ClientIds {
  MGM_APP_WEB = 'mgm_app_web',
  BET_MGM = 'bet_mgm',
  PASSKEY = 'passkey',
  HOLIDAY_GIFT_SHOP = 'holiday_gift_shop',
}

export type ClientId = `${ClientIds}`;

export const enum Features {
  BYPASS_GUIDED_SIGN_IN = 'BypassGuidedSignIn',
  HIDE_FORGOT_PASSWORD_LINK = 'HideForgotPasswordLink',
  ALLOW_OKTA_SIGN_IN_WITH_REDIRECT = 'AllowOktaSignInWithRedirect',
  PREVENT_AUTO_SIGN_IN = 'PreventAutoSignIn',
  ALLOW_ONLY_SIGN_IN = 'AllowOnlySignIn',
  DISPLAY_MGM_REWARDS_PROMO_BANNER = 'DisplayMGMRewardsPromoBanner',
  MFA_ENABLED = 'MfaEnabled',
  PASSKEY_ENABLED = 'PasskeyEnabled',
  IDX_API_ENABLED = 'IdxApiEnabled',
  POST_SIGNIN_2FA_ENROLLMENT_ENABLED = 'PostSignIn2faEnrollmentEnabled',
}

export type FeaturesKeys = keyof typeof Features;
export type FeaturesValues = `${Features}`;

export const FeaturesByClientIds: Record<FeaturesKeys, ClientId[]> = {
  BYPASS_GUIDED_SIGN_IN: [ClientIds.PASSKEY],
  HIDE_FORGOT_PASSWORD_LINK: [ClientIds.BET_MGM, ClientIds.PASSKEY, ClientIds.HOLIDAY_GIFT_SHOP],
  ALLOW_OKTA_SIGN_IN_WITH_REDIRECT: [ClientIds.BET_MGM, ClientIds.PASSKEY, ClientIds.HOLIDAY_GIFT_SHOP],
  PREVENT_AUTO_SIGN_IN: [ClientIds.PASSKEY, ClientIds.HOLIDAY_GIFT_SHOP], // overrides by FF in usePreventAutoSignIn hook
  ALLOW_ONLY_SIGN_IN: [ClientIds.BET_MGM, ClientIds.PASSKEY, ClientIds.HOLIDAY_GIFT_SHOP],
  DISPLAY_MGM_REWARDS_PROMO_BANNER: [ClientIds.MGM_APP_WEB],
  MFA_ENABLED: [ClientIds.MGM_APP_WEB],
  PASSKEY_ENABLED: [ClientIds.MGM_APP_WEB],
  IDX_API_ENABLED: [ClientIds.MGM_APP_WEB],
  POST_SIGNIN_2FA_ENROLLMENT_ENABLED: [ClientIds.MGM_APP_WEB],
};

export const ScopesByClientIds: { [key in ClientId | 'default_third_party_client']?: string[] } = {
  // for mgm_app_web AuthSDK provides scopes for member/signed-in or transient users
  default_third_party_client: ['profile:read', 'openid'], // scopes for third-party clients e.g., bet_mgm, passkey
  [ClientIds.HOLIDAY_GIFT_SHOP]: ['profile', 'openid', 'offline_access'], // scopes for holiday_gift_shop
};
